import React from 'react';
import shallowEqual from 'shallowequal';
import { PricePrice } from 'src/types';
import { Align } from '../../../../types';
import * as S from './styles';
import ShippingLabel from './shipping-label';
import PriceLabel from './price-label';
import { PriceDisplay } from 'src/areas/product/types';

type OwnProps = {
  price: PricePrice;
  storeIsFeatured?: boolean | null;
  isCampaign: boolean;
  align?: Align;
  priceDisplay: PriceDisplay;
};

const PriceColumn = React.memo(
  ({ price, storeIsFeatured, isCampaign, align, priceDisplay }: OwnProps) => {
    return (
      <S.PriceColumn align={align}>
        {storeIsFeatured && (
          <ShippingLabel price={price} priceDisplay={priceDisplay} />
        )}
        <PriceLabel
          price={price}
          priceDisplay={priceDisplay}
          storeIsFeatured={storeIsFeatured}
          isCampaign={isCampaign}
        />
      </S.PriceColumn>
    );
  },
  (prevProps, nextProps) => {
    const { price: prevPrice, ...prevRest } = prevProps;
    const { price: nextPrice, ...nextRest } = nextProps;
    return (
      shallowEqual(prevPrice, nextPrice) && shallowEqual(prevRest, nextRest)
    );
  }
);

export default PriceColumn;
